<template>
  <v-app class="app">
    <app-toolbar-new-user class="app--toolbar" />
    <v-main>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <router-view />
      </div>
      <!-- App Footer -->
      <v-footer height="auto" class="white pa-3 app--footer">
        <span class="caption">X-zam Laboratories &copy; {{ new Date().getFullYear() }}</span>
        <v-spacer></v-spacer>
      </v-footer>
    </v-main>
    <!-- Go to top -->
    <app-fab />
  </v-app>
</template>

<script>
import AppToolbarNewUser from '@/components/AppToolbarNewUser'
import AppFab from '@/components/AppFab'

export default {
  name: 'LayoutNewUser',
  components: {
    AppToolbarNewUser,
    AppFab,
  },

  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="sass" scoped>
.page-wrapper
  min-height: calc(100vh - 64px - 44px)
</style>
